import { useTranslation } from 'next-i18next';
import { useCallback, useState } from 'react';

import { upsertWorkspaceDraft, useAppDispatch, useAppSelector } from '../state';
import { message } from '../ui';

export function useSaveDraft() {
  const edit = useAppSelector((state) => state.edit);
  const dispatch = useAppDispatch();
  const [saving, setSaving] = useState(false);
  const { t } = useTranslation();
  const [saveTime, setSaveTime] = useState<Date | null>(null);
  const saveDraft = useCallback(async () => {
    if (saving) return;
    try {
      setSaving(true);

      dispatch(
        upsertWorkspaceDraft({
          params: {
            npc_id: edit.npcId,
            setting_info: edit.settingInfo,
            img_info: edit.imgInfo,
            voice_info: edit.voiceInfo,
            plugin_list: edit.pluginList,
          },
        })
      )
        .then(() => {
          setSaveTime(new Date());
          message.success(t('saveSuccess'));
        })
        .catch((err) => {
          message.error(err.status_msg || err.msg || t('saveFail'));
        });
    } finally {
      setSaving(false);
    }
  }, [dispatch, edit.imgInfo, edit.npcId, edit.settingInfo, edit.voiceInfo, saving, t]);

  return {
    saveDraft,
    saving,
    saveTime,
  };
}
